"use client";
import ScreenLayout from "@/components/layout/screen-layout";
import { ImgAboutUsLightDevBg } from "@/lib/images";
import Image from "next/image";

function AboutStory() {
    return (
        <div className="md:pb-17.5 pb-9 relative py-20 bg-[#edf1fd]">
            <ScreenLayout>
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                        {/* Left Column - Text Section */}
                        <div className="bg-white rounded-xl p-8 shadow-sm h-full flex flex-col justify-start">
                            <div className="space-y-6">
                                {/* Primary Color Label */}
                                <div className="inline-block">
                                    <span className="uppercase text-sm font-semibold text-[#5231E7] tracking-wide">
                                        How It Started
                                    </span>
                                </div>

                                {/* Main Heading */}
                                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                                    Our Dream is Global Digital Transformation
                                </h2>

                                {/* Paragraph */}
                                <p className="text-lg text-gray-600 leading-relaxed">
                                    Devkrest was founded by passionate technologists and visionary entrepreneurs who shared a common dream: to democratize technology and make digital transformation accessible to businesses of all sizes. United by their belief in the transformative power of technology, they embarked on a journey to build innovative solutions that bridge the gap between complex technical challenges and real-world business needs. With relentless dedication, they gathered a team of experts and launched this innovative platform, creating a global community of eager learners and businesses, all connected by the desire to explore, innovate, and grow in the digital age.
                                </p>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="bg-white rounded-xl p-8 shadow-sm h-full flex flex-col justify-start space-y-8">
                            {/* Top Section - Image */}
                            <div className="relative">
                                <div className="relative rounded-xl overflow-hidden">
                                    <Image
                                        src={ImgAboutUsLightDevBg}
                                        alt="Devkrest team working together"
                                        width={200}
                                        height={150}
                                        className="w-full h-100 object-cover rounded-lg"
                                    />
                                </div>
                            </div>

                            {/* Bottom Section - Stats Grid */}
                            <div className="grid grid-cols-2 gap-4">
                                {/* Top Left */}
                                <div className="bg-blue-50 rounded-xl p-6 text-center">
                                    <div className="text-2xl font-bold text-gray-900">5+</div>
                                    <div className="text-sm text-gray-500 mt-1">Years Average Team Experience</div>
                                </div>

                                {/* Top Right */}
                                <div className="bg-blue-50 rounded-xl p-6 text-center">
                                    <div className="text-2xl font-bold text-gray-900">20+</div>
                                    <div className="text-sm text-gray-500 mt-1">Countries Served</div>
                                </div>

                                {/* Bottom Left */}
                                <div className="bg-blue-50 rounded-xl p-6 text-center">
                                    <div className="text-2xl font-bold text-gray-900">80+</div>
                                    <div className="text-sm text-gray-500 mt-1">Projects Delivered</div>
                                </div>

                                {/* Bottom Right */}
                                <div className="bg-blue-50 rounded-xl p-6 text-center">
                                    <div className="text-2xl font-bold text-gray-900">$10M+</div>
                                    <div className="text-sm text-gray-500 mt-1">Client Business Managed</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScreenLayout>
        </div>
    );
}

export default AboutStory; 